import { __awaiter } from '../../../../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { useRef, useCallback, useMemo } from 'react';
import { SignMessageConfirmationModal } from '../../../modals/SignMessageConfirmationModal/SignMessageConfirmationModal.js';
import { TransactionConfirmationModal } from '../../../modals/TransactionConfirmationModal/TransactionConfirmationModal.js';
import { useConfirmationModal } from '../useConfirmationModal/useConfirmationModal.js';
import '../../constants/colors.js';
import '@dynamic-labs/multi-wallet';
import { getAuthToken } from '../../functions/getAuthToken/getAuthToken.js';
import '@dynamic-labs/sdk-api';

const useWalletUiUtils = ({ appLogoUrl, appName, getAppOrigin, }) => {
    const fakeSignerRef = useRef('disabled');
    const { modal: sendTransactionModal, open: openSendTransaction } = useConfirmationModal({
        elementId: 'dynamic-send-transaction',
    });
    const { modal, open: openSignMessage } = useConfirmationModal({
        elementId: 'dynamic-sign-message',
    });
    const signMessage = useCallback(({ message, handler }) => {
        const jwt = getAuthToken();
        if (!jwt && fakeSignerRef.current === 'enabled') {
            fakeSignerRef.current = 'disabled';
            return handler(message);
        }
        return openSignMessage((resolve, reject) => (jsx(SignMessageConfirmationModal, { appLogoUrl: appLogoUrl, appName: appName, appOrigin: getAppOrigin(), message: message, handler: handler, onSignMessage: resolve, onReject: reject })));
    }, [appLogoUrl, appName, getAppOrigin, openSignMessage]);
    const sendTransaction = useCallback(({ transaction, handler, provider }) => __awaiter(void 0, void 0, void 0, function* () {
        return openSendTransaction((resolve, reject) => (jsx(TransactionConfirmationModal, { title: 'Send Transaction', appLogoUrl: appLogoUrl, appName: appName, appOrigin: getAppOrigin(), transaction: transaction, handler: handler, onTransactionResponseSuccess: resolve, onReject: reject, provider: provider })));
    }), [appLogoUrl, appName, getAppOrigin, openSendTransaction]);
    const enableInternalSign = useCallback(() => {
        fakeSignerRef.current = 'enabled';
    }, []);
    const walletUiUtils = useMemo(() => ({
        enableInternalSign,
        sendTransaction,
        signMessage,
    }), [signMessage, enableInternalSign, sendTransaction]);
    return useMemo(() => [modal || sendTransactionModal, walletUiUtils], [modal, sendTransactionModal, walletUiUtils]);
};

export { useWalletUiUtils };
